import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import PageBanner from "@/components/PageBanner";
import { Bird, Cat, Map, Camera } from "lucide-react";

const features = [
  {
    icon: Map,
    title: "Extensive Coverage",
    description: "10 National Parks in Uganda, including Queen Elizabeth, Murchison Falls, and Kibale"
  },
  {
    icon: Cat,
    title: "Rich Wildlife",
    description: "Over 1,000 species of mammals, including the Big Five (lion, leopard, rhinoceros, elephant, and Cape buffalo)"
  },
  {
    icon: Bird,
    title: "Bird Paradise",
    description: "1,073 bird species in Uganda, including the iconic shoebill stork, African fish eagle, and lilac-breasted roller"
  },
  {
    icon: Camera,
    title: "Regional Exploration",
    description: "Explore the Maasai Mara National Reserve in Kenya, the Serengeti National Park in Tanzania, and the Volcanoes National Park in Rwanda"
  }
];

export default function WildlifeBirdingSafaris() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Wildlife & Birding Safaris | Ecoplace Tours</title>
        <meta
          name="description"
          content="Experience thrilling wildlife and birding adventures across East Africa's most spectacular national parks and game reserves."
        />
      </Helmet>

      <PageBanner
        title="Wildlife & Birding Safaris"
        description="Embark on thrilling wildlife and birding adventures with our expert guides and drivers, who possess in-depth knowledge of Uganda's, Kenya's, Tanzania's, and Rwanda's national parks and game reserves."
        backgroundImage="/5O5A9186.JPG"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {feature.title}
                </h3>
              </div>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <p className="text-lg text-black-600 max-w-3xl mx-auto font-bold">
            Our guided safaris ensure a safe and unforgettable experience with expert guides who know every corner of East Africa's most spectacular wildlife destinations.
          </p>
        </motion.div>
      </div>
    </div>
  );
}